import { render, staticRenderFns } from "./PPMList.vue?vue&type=template&id=57ee1949&scoped=true"
import script from "./PPMList.vue?vue&type=script&lang=ts"
export * from "./PPMList.vue?vue&type=script&lang=ts"
import style0 from "./PPMList.vue?vue&type=style&index=0&id=57ee1949&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ee1949",
  null
  
)

export default component.exports